import { Component, OnInit } from '@angular/core';

import * as applicationConstants from '../../constants/application-constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    applicationConstants: any;

    ngOnInit() {
        this.applicationConstants = applicationConstants.ApplicationConstants;
    }
}
